<template>
  <v-app>
    <portal-sysbar></portal-sysbar>

    <div class="home-content">
      <portal-aside></portal-aside>

      <div>
        <v-row class="d-flex justify-center mb-7">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 16 : 2"
              class="homeboxes text-center mr-4 ml-4 mb-1"
              @click="openProfil"
            >
              <v-card-text>
                <h2>{{ $t("message.home.team", { value: "default" }) }}</h2>
                <v-carousel
                  v-model="model"
                  hide-delimiters
                  height="170"
                  align="center"
                  class="mt-0"
                >
                  <v-carousel-item v-for="(team, idx) in teams" :key="idx">
                    <v-sheet color="#fff" light>
                      <v-row dense align="center" class="px-16 py-2">
                        <v-col md="3" class="">
                          <v-icon size="70" color="#00475A">
                            mdi-account-circle
                          </v-icon>
                        </v-col>
                        <v-col class="teambox pr-auto" style="color: #00475a">
                          <h4>{{ team.name }}</h4>
                          <span>{{ team.telephone }}</span
                          ><br />
                          <span>{{ team.profilname }}</span
                          ><br />
                          <span style="color: #7fc7b2">{{ team.mail }}</span>
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
              </v-card-text>
            </v-card>
          </v-hover>
         <!--
          <v-hover v-slot="{ hover }">
            <v-card
            class="homeboxes text-center ml-4 mr-4 mb-1"
            @click="openDoc"            
            :elevation="hover ? 16 : 2" 
            v-if="profile?.extrawork && profile?.validateQuote"
          >
            <v-card-text>
              <div class="quote-card">
                <v-icon class="notif-certif">mdi-bell-alert-outline</v-icon>
                <h1> {{ certificats.length }} </h1>
                <div class="quote-card-text">
                  <h2>DELIVRY / REDELIVRY</h2>
                  <h2>ON THE WAY</h2>
                </div>  
              </div>
              <v-carousel
                v-model="model"
                hide-delimiters
                height="170"
                align="center"
                class="mt-0"
              >
                <v-carousel-item v-for="(certificat, idx) in certificats" :key="idx">
                  <v-sheet color="#fff" light>
                    <v-row dense align="center" class="px-16 py-10">
                      <v-col class=" pr-auto" style="color: #00475a">
                        <h1>{{ certificat.asset }}</h1>
                        <br>
                        <span style="color: #7fc7b2">{{ getCertificateDate(certificat) }}</span>
                        <br />
                        <span>{{ $t(getCertifiteType(certificat.type)) }}</span>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </v-card-text>
          </v-card>
           </v-hover>

         -->
         
       
          <v-hover v-slot="{ hover }">
            <v-card 
              :elevation="hover ? 16 : 2"
              class="homeboxes text-center ml-4 mr-4 mb-1"
              @click="openKm"
              :loading="loading"
            >
              <v-card-text>
                <h2>{{ $t("message.aside.km", { value: "default" }) }}</h2>
                <v-sheet>
                  <v-row class="d-flex justify-center mt-7" style="height: 30px">
                    <span class="km">{{ totalKm }}</span>
                    <span
                      class="pl-1"
                      style="
                        font-size: 20px;
                        color: #7fc7b2;
                        font-weight: bolder;
                        margin-top: 8px;
                      "
                      >Km</span
                    >
                  </v-row>
                  <v-row class="d-flex justify-center">
                    <span
                    style="
                      color: #00475a;
                      font: normal normal normal 19px/23px Calibri;
                    "
                    >{{ $t("message.in", { value: "default" }) }} {{ year }}</span
                  >
                  </v-row>
                  <v-sparkline
                    :value="value"
                    auto-draw
                    color="#7FC7B2"
                    line-width="1"
                    height= 35
                  ></v-sparkline>
                </v-sheet>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }">
            <v-card
              class="homeboxes text-center ml-4 mr-4 mb-1"
              @click="openQuotes"            
              :elevation="hover ? 16 : 2" 
              v-if="numberQuotesToValidate > 0 && profile?.extrawork && profile?.validateQuote"
            >
              <v-card-text>
                <div class="quote-card">
                  <v-icon
                    class="notif"
                    v-if="notifQuote"
                  >mdi-bell-alert-outline</v-icon>
                  <h1> {{ numberQuotesToValidate }} </h1>
                  <div class="quote-card-text">
                    <h2>{{ $t("message.extrawork.newquote", { value: "default" }) }}</h2>
                    <h2>{{ $t("message.extrawork.quotewaiting", { value: "default" }) }}</h2>
                  </div>  
                </div>
                
                <v-sheet class="quote-img">
                  <img
                    src="@/assets/devis.png"
                    height="100"
                    width="100"
                    :class="{ 'on-hover': hover }"
                  />
                </v-sheet>
              </v-card-text>
            </v-card>
          </v-hover>
          
          <v-hover v-slot="{ hover }">
            <v-card
              class="homeboxes text-center ml-4 mr-4 mb-1"
              @click="toInternLoco"
              :elevation="hover ? 16 : 2" 
              v-if="getterUser.internal"
            >
              <v-card-text>
                <h2>{{ $t('message.home.locoInfo') }}</h2>
                  <img
                    src="@/assets/hotline.png"
                    height="100"
                    width="100"
                    :class="{ 'on-hover': hover }"
                  />
              </v-card-text>
            </v-card>
          </v-hover>
          
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 16 : 2"
              class="homeboxes text-center ml-4 mr-4 mb-1"
              @click="openDispo"
            >
              <v-card-text>
                <h2>{{ $t("message.dispoc.widgetText", { value: "default" }) }}</h2>             
                <v-sheet>
                  <img
                    src="@/assets/dispoc.png"
                    height="160"
                  />
                </v-sheet>
              </v-card-text>
            </v-card>
          </v-hover>

          

           <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 16 : 2"
              class="homeboxes text-center ml-4 mr-4 mb-1"
              @click="openGeoloc"
            >
              <v-card-text>
                <h2>{{ $t("message.aside.geo", { value: "default" }) }}</h2>
                <v-sheet>
                  <img
                    src="@/assets/europe_map.svg"
                    height="160"
                    
                  />
                </v-sheet>
              </v-card-text>
            </v-card>
          </v-hover>

          
        </v-row> 

        <v-row class="notice d-flex justify-center">
          <div>{{ $t("message.rgpd", { value: "default" }) }}</div>
        </v-row>
      </div>
    </div>


  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import {
  firstDateOfCurrentYear,
  currentDate,
  currentYear,
  numStr,
  formatInfoDate
} from "@/shared/DateHelper";
import { getDocType } from "@/shared/Helper"
import { mapGetters, mapActions } from "vuex";
import CascService from "@/services/CascService";
import CoreService from '@/services/CoreService.js'
import TeamsService from "@/services/TeamsService";
import QuoteService from "@/services/QuoteService";
import { getProfile } from "@/shared/UserProfile";

export default {
  title: "Dashboard",
  watch: {
    getterCurrentClient() {
      this.getTeams(), 
      this.loadlocomotives(),
      this.getNumQuotesToValidate(), 
      this.getCertificate();
    },
    getterLocos() {
      this.getTotalKm()
    }
  },
  methods: {
    ...mapActions("customer", {
      actionLoadLoco: "loadLocos",
    }),

    ...mapActions("auth", {
      actionGetClients: "loadClients",
      actionGetContrats: "loadContrats",
    }),

    async initData() {
      if (this.getterAdUser === true) {
        await this.actionGetClients();
      }
      await this.actionGetContrats(this.getterCurrentClient);
      await this.loadlocomotives();
    },

    getCertifiteType(type){
      return getDocType(type)
    },

    async loadlocomotives() {
      let payload = {
        customer: this.getterCurrentClient,
        start: currentDate(),
        end: currentDate(),
      };
      await this.actionLoadLoco(payload)
    },

    getTotalKm() {
      let payload = {
        startdate: firstDateOfCurrentYear(),
        enddate: currentDate(),
        clients: [this.getterCurrentClient],
        locomotives: this.getterLocos.map(l => l.loconum),
        contrats: this.getterContrats,
      };
      if (!payload.locomotives.length) {
        this.totalKm = 0;
        return;
      }

      CascService.findTotalDistanceByCustomer(payload).then((response) => {
        this.totalKm = 0;
        if (response.data.length > 0 && response.data[0].totalkm != null) {
          this.totalKm = numStr(response.data[0].totalkm.toFixed(0));
        }

        this.loading = false;
      });
    },

    getCertificateDate(certificat){
      return formatInfoDate(certificat.type == "LIVRAISON" ? certificat.lesingStartDate : certificat.lesingEndDate,
      this.$i18n.locale)
    },

    getCertificate(){
      CoreService.findCertificateTovalidate(this.getterCurrentClient).then(
        (response) => {
          this.certificats = response.data
        }
      )
    },

    getTeams() {
      TeamsService.findTeamsByCustomer(this.getterCurrentClient).then(
        (response) => {
          this.teams = response.data;
        }
      );
    },

    openProfil() {
      this.$router.push("/team");
    },

    openDoc() {
      this.$router.push("/edl");
    },

    openGeoloc() {
      this.$router.push("/geoloc");
    },
    openKm() {
      this.$router.push("/km");
    },
    openDispo() {
      this.$router.push("/disponibility");
    },
    toInternLoco() {
      this.$router.push("/intern/loco")
    },

    getYear() {
      this.year = currentYear();
    },

    getNumQuotesToValidate() {
      QuoteService.loadQuotesToValidate(this.getterCurrentClient).then(
        (response) => {
          this.numberQuotesToValidate = response.data.length;
        }
      );
      
    },
    openQuotes() {
      this.$router.push("/quotes");
    },
  },
  name: "HomePage",
  components: {
    PortalSysbar,
    PortalAside,
  },
  mounted() {
    this.initData(),
      this.getTotalKm(),
      this.getTeams(),
      this.getYear(),
      this.getNumQuotesToValidate()
      this.getCertificate()
    this.profile = getProfile(this.getterAuthData.profils,this.getterFunctionnalities);
  },
  computed: {
    ...mapGetters("auth", {
      getterContrats: "getContrats",
      getterAdUser: "isAdUser",
      getterCurrentClient: "getCurrentClient",
      getterAuthData: "getAuthData",
      getterFunctionnalities: "getFunctionnalities",
      getterUser: "getUserContact",
    }),
    ...mapGetters("customer", {
      getterFleet: "getFleat",
      getterLocos: "getLocos",
    }),
    notifQuote() {
      return this.numberQuotesToValidate > 0;
    },
  },
  data: () => ({
    model: 0,
    totalKm: 0,
    dialog: false,
    dispoLoc: [],
    year: "",
    value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
    loading: false,
    teams: [],
    numberCertificat: 1,
    certificats:[],
    numberQuotesToValidate: null,
    profile : {
      extrawork: false,
      validateQuote: false,
      rejectQuote: false,
    }
  }),
};
</script>

<style scoped>
.homeboxes {
  background: #fff;
  height: 240px;
  align-content: center;
  width: 400px;
  color: "#00475A";
  padding: 10px 5px 10px 5px;
  margin-top: 2%;
   
}

.notice {
  font-size: 0.7em;
  color: #9faaaf;
  text-align: justify;
  display: table;
}

.notice > div {
  padding-top: 20px;
  width: 870px;
  display: table-row;
  position: absolute;
  bottom: 10px;
}

.homeboxes h2 {
  text-transform: uppercase;
}

.text {
  font-style: italic;
  color: #00475a;
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 1em;
}

.teambox {
  color: "#00475A";
  text-align: right;
  overflow: auto;
}

.km {
  color: #7fc7b2;
  font-size: 45px;
  font-weight: bolder;
  display: block;
  bottom: 5px;
}

.theme--light.v-card > .v-card__text,
.theme--light.v-card .v-card__subtitle {
  color: #00475a;
}


.quote-card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.quote-card > h2, .quote-card > h1{
 color:  #a0d5c5;
 text-align: left;
}

.quote-card-text {
  display: flex;
  flex-direction: column;
  justify-content: left;
}

.quote-card-text > h2{
 text-align: left;
}

.quote-card > h1{
 font-size: 60px;
}

.quote-card-text > h2:last-child{
  color:  #a0d5c5;
}

.quote-img {
 margin: 35px 45% 0 auto;
 width: 100px;
 height: 100px;
 position: relative;
}

.quote-img img {
  filter: invert(1);
  transition: color 0.5s;
  position: relative;
  z-index: 10;
}

.quote-img::after{
  content: '';
  background: linear-gradient(to right, #d1d5a0, rgb(148, 179, 169));
  width:200px;
  height: 200px;
  transform: scale(1.1);
  position: absolute;
  left: 28px;
  top: -45px;
  transition: 0.5s;
  border-radius: 50% 20% / 10% 40%;
  background-image: url("../assets/blob.svg");
}

.quote-img::before{
  content: '';
  background: linear-gradient(to right, #d1d5a0, rgb(148, 179, 169));
  width: 70px;
  height: 70px;
  transform: scale(1.1);
  position: absolute;
  left: 95px;
  top: 15px;
  transition: 0.5s;
  border-radius: 50% 20% / 10% 40%;
  background-image: url("../assets/list.svg");
  background-size: contain;
  z-index: 5;
}

@keyframes notif   {
  0% {
    rotate: 0deg;
  }
  25% {
    rotate: 25deg;
  }
  50% {
    rotate: -25deg;
  }
  100% {
    rotate: 0deg;
  }
}

.notif {
  color:  #00475a;
  animation: notif 1.3s  0s infinite;
}

.notif:hover{
  animation: none;
  color: #a0d5c5;
}

@keyframes notif-certif  {
  0% {
    rotate: 0deg;
  }
  25% {
    rotate: 25deg;
  }
  50% {
    rotate: -25deg;
  }
  100% {
    rotate: 0deg;
  }
}

.notif-certif {
  color:  #00475a;
  visibility: visible;
  animation: notif 1.3s  0s infinite;
}

.notif-certif:hover{
  animation: none;
  color: #a0d5c5;
}



</style>
